import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useUnlockOrderMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useUnlockOrder = () => {
  const [handle, { loading, error: apolloError }] = useUnlockOrderMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    unlock: useCallback(
      async (id: string) => {
        const res = await handle({ variables: { id } });
        return !!res.data?.unlock;
      },
      [handle]
    ),
  };
};
